export const range = (end: number, start: number = 1) =>
    Array.from({length: (end + 1 - start)}, (value, key) => key + start);

export const modulo = (a: number, m: number): number => ((a % m) + m) % m;

export const nvl = (n: number | undefined, or: number) => undefined !== n ? n : or;
